export const sharedConstants = {
  IS_GALLERY_UPLOAD_PREVIEW: "IS_GALLERY_UPLOAD_PREVIEW",
  KB_TO_MB_BYTES: 1048576, //1024 * 1024 = 1048576
};
